import React from 'react';
import {
  CircularProgress,
  Button,
  Box,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import Response from './Response';
import EndpointArgs from './EndpointArgs';

export default function Modal({
  modalOpen,
  modalEndpoint,
  responses,
  loading,
  handleCloseModal,
  fetchDataForEndpoint,
  setEndpointArgs,
}) {
  if (!modalEndpoint) return null;

  return (
    <Dialog
      open={modalOpen}
      onClose={handleCloseModal}
      fullWidth
      maxWidth="xl"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box
        sx={{
          bgcolor: 'background.paper',
          p: 4,
          overflow: 'auto',
          position: 'relative',
        }}
      >
        <DialogTitle>
          {modalEndpoint.path.substr(1).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
        </DialogTitle>
        {responses[modalEndpoint.path] && (
          <DialogContent>
            {loading[modalEndpoint.path] ? (
              <CircularProgress />
            ) : (
              <Response response={responses[modalEndpoint.path]} />
            )}
          </DialogContent>
        )}
        <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Stack direction="row" sx={{ width: '100%' }}>
            <EndpointArgs
              endpoint={modalEndpoint}
              fetchDataForEndpoint={fetchDataForEndpoint}
              setEndpointArgs={setEndpointArgs}
            />
          </Stack>
          <Button onClick={handleCloseModal}>Close</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
